import React, { createContext, useState, useContext } from "react";
import ReactModal from "react-modal";
import Button from "@material-ui/core/Button";

const ModalContext = createContext();

export const useModal = () => useContext(ModalContext);

const modalButtonStyle = {
    padding: "8px 16px",
    borderRadius: "8px",
    cursor: "pointer",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "24px",
    textAlign: "center",
    color: "#FFFFFF",
    marginLeft: "10px",
    outline: "none",
    border: "none",
    textTransform: "none",
};

const blackButtonStyle = {
    backgroundColor: "#1F1F1F",
    marginTop: "15px",
};

const modalButtonContainerStyle = {
    textAlign: "center",
};

export const ModalProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [modalText, setModalText] = useState("");

    const showModal = (text) => {
        if (text != "") {
            setModalText(text);
            setIsOpen(true);
        }
    };

    const closeModal = () => {
        setIsOpen(false);
        setModalText("");
    };

    return (
        <ModalContext.Provider value={{ showModal, closeModal }}>
            {children}
            <ReactModal
                isOpen={isOpen}
                onRequestClose={closeModal}
                ariaHideApp={false}
                className="custom-modal"
                overlayClassName="custom-modal-overlay"
            >
                <div>
                    <div style={{ whiteSpace: "pre-line" }}>{modalText}</div>
                    <div style={modalButtonContainerStyle}>
                        <Button
                            style={{ ...modalButtonStyle, ...blackButtonStyle }}
                            onClick={closeModal}
                        >
                            Закрыть
                        </Button>
                    </div>
                </div>
            </ReactModal>
        </ModalContext.Provider>
    );
};
